import React from 'react';

const ShopSkeleton = () => {
  // Generate exactly 16 placeholders to match the default limit size
  const skeletons = Array.from({ length: 16 }, (_, index) => index);

  return (
    <div className="shop-skeleton-grid">
      {skeletons.map((idx) => (
        <div key={idx} className="shop-skeleton-card">
          <div className="shop-skeleton-image-wrapper skeleton-pulse" />
          <div className="shop-skeleton-info">
            <div className="shop-skeleton-badge skeleton-pulse" />
            <div className="shop-skeleton-title skeleton-pulse" />
            <div className="shop-skeleton-meta">
              <div className="shop-skeleton-price skeleton-pulse" />
              <div className="shop-skeleton-moq skeleton-pulse" />
            </div>
            <div className="shop-skeleton-actions">
              <div className="shop-skeleton-btn skeleton-pulse" />
              <div className="shop-skeleton-btn skeleton-pulse" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ShopSkeleton;
